import { SVGProps } from 'react';

export default function ProductsTooltipInfoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      {...props}
    >
      <path d="M5 1C2.79086 1 1 2.79086 1 5C1 7.20914 2.79086 9 5 9C7.20914 9 9 7.20914 9 5C9 2.79086 7.20914 1 5 1ZM0 5C0 2.23858 2.23858 0 5 0C7.76142 0 10 2.23858 10 5C10 7.76142 7.76142 10 5 10C2.23858 10 0 7.76142 0 5Z" fill="#949494" />
      <path d="M5 4C5.27614 4 5.5 4.22386 5.5 4.5V7.5C5.5 7.77614 5.27614 8 5 8C4.72386 8 4.5 7.77614 4.5 7.5V4.5C4.5 4.22386 4.72386 4 5 4Z" fill="#949494" />
      <path d="M5.75 2.75C5.75 3.16421 5.41421 3.5 5 3.5C4.58579 3.5 4.25 3.16421 4.25 2.75C4.25 2.33579 4.58579 2 5 2C5.41421 2 5.75 2.33579 5.75 2.75Z" fill="#949494" />
    </svg>
  );
}
